import { ofType } from 'redux-observable';
import { mapTo } from 'rxjs/operators';

import { LOGIN } from 'modules/auth/actions/login';
import { UPDATE_JWT_TOKEN_UNPOSSIBLE } from 'modules/session/actions/updateJwtToken';
import { EXTERNAL_LOGIN } from '../actions/externalLogin';

export const removeLocalStorageJWT = action$ =>
  action$.pipe(
    ofType(LOGIN.failure, UPDATE_JWT_TOKEN_UNPOSSIBLE, EXTERNAL_LOGIN.failure),
    mapTo(() => localStorage.removeItem('jwt')),
  );
